import {ClipboardCheck, GraduationCap, UserPlus, Users} from 'lucide-react';
import RenderIf from "@/components/render-if";
import React from 'react'


export default function GatewayAcademyCardSection({academy, onSelect}) {
    const {user_academies} = academy;
    const hasRoles = user_academies?.student || user_academies?.teacher || user_academies?.expert;

    const roles = [
        {key: 'student', label: 'دانش‌آموز', icon: GraduationCap, active: user_academies?.student === 1},
        {key: 'teacher', label: 'مربی', icon: Users, active: user_academies?.teacher === 1},
        {key: 'admin', label: 'کارشناس', icon: ClipboardCheck, active: user_academies?.expert === 1},
    ];


    const activeRoles = roles.filter(role => role.active);

    return (
        <div
            className="rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group border border-gray-100 dark:border-gray-600">
            <RenderIf condition={academy.logo}>
                <div
                    className="relative h-48 bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-emerald-900 dark:to-teal-800 flex items-center justify-center p-6">
                    <img
                        src={academy.logo}
                        alt={academy.name}
                        className="max-h-[150px]  max-w-[150px] rounded-lg object-contain group-hover:scale-105 transition-transform duration-300"

                    />
                </div>
            </RenderIf>

            <div className="p-6">
                <h3 className="text-xl font-bold mb-3 text-center">
                    {academy.name}
                </h3>

                <RenderIf condition={false}>
                    <p className="text-sm mb-4 text-right leading-relaxed line-clamp-3">
                        {academy.desc}
                    </p>

                </RenderIf>


                {hasRoles ? (
                    <div className="space-y-2">
                        <p className="text-xs  text-right mb-3">ورود با نقش:</p>
                        {activeRoles.map((role, index) => {
                            const Icon = role.icon;
                            const ExpertOld = <button
                                key={role.key + '-btn-select-academy' + index + 'admin'}
                                onClick={() => onSelect(academy, 'old-admin')}
                                className="w-full flex items-center justify-between gap-3 px-4 py-3 rounded-xl bg-gradient-to-l from-emerald-500 to-teal-600 text-white hover:from-emerald-600 hover:to-teal-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                            >
                                <span className="font-medium">کارشناس - سامانه قدیم</span>
                                <ClipboardCheck className="w-5 h-5"/>
                            </button>

                            return (
                                <React.Fragment key={role.key + '-btn-select-academy' + index}>
                                    <button
                                        onClick={() => onSelect(academy, role.key)}
                                        className="w-full flex items-center justify-between gap-3 px-4 py-3 rounded-xl bg-gradient-to-l from-emerald-500 to-teal-600 text-white hover:from-emerald-600 hover:to-teal-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                                    >
                                        <span className="font-medium">{role.label}</span>
                                        <Icon className="w-5 h-5"/>
                                    </button>
                                    <RenderIf condition={role.key === 'admin'}>
                                        {ExpertOld}
                                    </RenderIf>
                                </React.Fragment>
                            );
                        })}
                    </div>
                ) : (
                    <button
                        onClick={() => onSelect(academy, 'student/first')}
                        className="w-full flex items-center justify-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-l from-blue-500 to-cyan-600 text-white hover:from-blue-600 hover:to-cyan-700 transition-all duration-200 shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                    >
                        <UserPlus className="w-5 h-5"/>
                        <span className="font-medium">ثبت‌نام</span>
                    </button>
                )}
            </div>
        </div>
    );
}
